import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  eidCommentsButton: {
    textTransform: "none",
    fontSize: 12,
    color: "#02c092",
    margin: -8
  },
  popoverRoot: {
    overflow: "inherit",
    marginTop: 9,
    [theme.breakpoints.down("xs")]: {
      width: "85vw"
    }
  },
  arrowUp: {
    width: 24,
    height: 24,
    backgroundColor: "#fff",
    boxShadow: `
    0px 5px 5px -3px rgb(0 0 0 / 20%),
    0px 8px 10px 1px rgb(0 0 0 / 14%),
    0px 3px 14px 2px rgb(0 0 0 / 12%)
    `,
    transform: "rotate(45deg)",
    position: "absolute",
    zIndex: 1,
    top: -8,
    right: 41
  },
  popover: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 330,
    backgroundColor: "#fff",
    position: "relative",
    zIndex: 999,
    borderRadius: 5,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "initial"
    }
  },
  popoverHeader: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    padding: 16,
    fontSize: 16
  },
  popoverContent: {
    padding: 16,
    fontSize: 14,
    color: theme.palette.text.primary,
    borderTop: "1px solid #eeeeee"
  }
}));
